import type { ReactNode } from "react";
import styles from "./ButtonLink.module.css";

interface ButtonLinkProps {
  /** Sem href vira <button> — usado pelos CTAs que abrem o modal. */
  href?: string;
  onClick?: () => void;
  children: ReactNode;
  variant?: "primary" | "onGreen" | "light";
  className?: string;
}

export function ButtonLink({
  href,
  onClick,
  children,
  variant = "primary",
  className,
}: Readonly<ButtonLinkProps>) {
  const css = [styles.button, styles[variant], className].filter(Boolean).join(" ");

  if (!href) {
    return (
      <button type="button" className={css} onClick={onClick}>
        {children}
      </button>
    );
  }

  // Link pra fora do site (WhatsApp, PDF de privacidade) abre em outra janela.
  const external = /^https?:/i.test(href) || href.endsWith(".pdf");

  return (
    <a
      className={css}
      href={href}
      onClick={onClick}
      target={external ? "_blank" : undefined}
      rel={external ? "noopener noreferrer" : undefined}
    >
      {children}
    </a>
  );
}
